"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var flatMap_1 = __importDefault(require("lodash/flatMap"));
var logs_1 = require("@ledgerhq/logs");
var errors_1 = require("@ledgerhq/errors");
var currencies_1 = require("../../../currencies");
var network_1 = __importDefault(require("../../../network"));
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var jsHelpers_2 = require("../../../bridge/jsHelpers");
var receive = (0, jsHelpers_2.makeAccountBridgeReceive)();
var neoAsset = "c56f33fc6ecfcd0c225c4ab356fee59390af8560be0e930faebe74a6daff7c9b";
var neoUnit = (0, currencies_1.getCryptoCurrencyById)("neo").units[0];
var txToOps = function (_a) {
    var id = _a.id, address = _a.address;
    return function (tx) {
        var ops = [];
        if (tx.asset !== neoAsset)
            return ops;
        var hash = tx.txid;
        var date = new Date(tx.time * 1000);
        var value = (0, currencies_1.parseCurrencyUnit)(neoUnit, tx.amount);
        var from = tx.address_from;
        var to = tx.address_to;
        var sending = address === from;
        var receiving = address === to;
        var fee = new bignumber_js_1.BigNumber(0);
        if (sending) {
            ops.push({
                id: "".concat(id, "-").concat(hash, "-OUT"),
                hash: hash,
                type: "OUT",
                value: value.plus(fee),
                fee: fee,
                blockHeight: tx.block_height,
                blockHash: null,
                accountId: id,
                senders: [from],
                recipients: [to],
                date: date,
                extra: {}
            });
        }
        if (receiving) {
            ops.push({
                id: "".concat(id, "-").concat(hash, "-IN"),
                hash: hash,
                type: "IN",
                value: value,
                fee: fee,
                blockHeight: tx.block_height,
                blockHash: null,
                accountId: id,
                senders: [from],
                recipients: [to],
                date: date,
                extra: {}
            });
        }
        return ops;
    };
};
var root = "https://api.neoscan.io";
function fetch(path) {
    return __awaiter(this, void 0, void 0, function () {
        var url, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = root + path;
                    return [4 /*yield*/, (0, network_1["default"])({
                            method: "GET",
                            url: url
                        })];
                case 1:
                    data = (_a.sent()).data;
                    (0, logs_1.log)("http", url);
                    return [2 /*return*/, data];
            }
        });
    });
}
function fetchBalances(addr) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/api/main_net/v1/get_balance/".concat(addr))];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.balance];
            }
        });
    });
}
function fetchBlockHeight() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/api/main_net/v1/get_height")];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.height];
            }
        });
    });
}
function fetchTxs(addr, shouldFetchMoreTxs) {
    return __awaiter(this, void 0, void 0, function () {
        var i, load, payload, txs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    i = 0;
                    load = function () {
                        return fetch("/api/main_net/v1/get_address_abstracts/".concat(addr, "/").concat(i + 1));
                    };
                    return [4 /*yield*/, load()];
                case 1:
                    payload = _a.sent();
                    txs = [];
                    _a.label = 2;
                case 2:
                    if (!(payload && i < payload.total_pages && shouldFetchMoreTxs(txs))) return [3 /*break*/, 4];
                    txs = txs.concat(payload.entries);
                    i++;
                    return [4 /*yield*/, load()];
                case 3:
                    payload = _a.sent();
                    return [3 /*break*/, 2];
                case 4: return [2 /*return*/, txs];
            }
        });
    });
}
var getAccountShape = function (info) { return __awaiter(void 0, void 0, void 0, function () {
    var blockHeight, balances, balanceMatch, balance, txs, operations;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchBlockHeight()];
            case 1:
                blockHeight = _a.sent();
                return [4 /*yield*/, fetchBalances(info.address)];
            case 2:
                balances = _a.sent();
                if (balances.length === 0) {
                    return [2 /*return*/, {
                            balance: new bignumber_js_1.BigNumber(0)
                        }];
                }
                balanceMatch = balances.find(function (b) { return b.asset_hash === neoAsset; });
                balance = balanceMatch
                    ? (0, currencies_1.parseCurrencyUnit)(neoUnit, String(balanceMatch.amount))
                    : new bignumber_js_1.BigNumber(0);
                return [4 /*yield*/, fetchTxs(info.address, function (txs) { return txs.length < 1000; })];
            case 3:
                txs = _a.sent();
                operations = (0, flatMap_1["default"])(txs, txToOps(info));
                return [2 /*return*/, {
                        balance: balance,
                        operations: operations,
                        blockHeight: blockHeight
                    }];
        }
    });
}); };
var scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: getAccountShape });
var sync = (0, jsHelpers_1.makeSync)({ getAccountShape: getAccountShape });
var currencyBridge = {
    preload: function () { return Promise.resolve({}); },
    hydrate: function () { },
    scanAccounts: scanAccounts
};
var createTransaction = function (a) {
    throw new errors_1.CurrencyNotSupported("neo currency not supported", {
        currencyName: a.currency.name
    });
};
var updateTransaction = function (t, patch) { return (__assign(__assign({}, t), patch)); };
var getTransactionStatus = function (a) {
    return Promise.reject(new errors_1.CurrencyNotSupported("neo currency not supported", {
        currencyName: a.currency.name
    }));
};
var estimateMaxSpendable = function () {
    return Promise.reject(new Error("estimateMaxSpendable not implemented"));
};
var prepareTransaction = function (a, t) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, Promise.resolve(t)];
}); }); };
var accountBridge = {
    createTransaction: createTransaction,
    updateTransaction: updateTransaction,
    prepareTransaction: prepareTransaction,
    getTransactionStatus: getTransactionStatus,
    estimateMaxSpendable: estimateMaxSpendable,
    sync: sync,
    receive: receive,
    signOperation: function () {
        throw new Error("signOperation not implemented");
    },
    broadcast: function () {
        throw new Error("broadcast not implemented");
    }
};
exports["default"] = {
    currencyBridge: currencyBridge,
    accountBridge: accountBridge
};
//# sourceMappingURL=js.js.map